import { useCallback, useState } from 'react';
import moment from 'moment';

const defaultDateRange = {
  startDate: moment().startOf('isoWeek').toDate(),
  endDate: moment().endOf('isoWeek').toDate(),
  key: 'selection',
  rangeType: 'This Week'
};

const getNavigateUnit = rangeType => {
  switch (rangeType) {
    case 'Last 12 Months':
    case 'This Year':
    case 'Last Year':
      return 'year';
    case 'Last 3 Months':
    case 'This Quarter':
    case 'Last Quarter':
      return 'quarter';
    case 'This Month':
    case 'Last Month':
      return 'month';
    case 'This Week':
    case 'Last Week':
      return 'week';
    case 'Today':
      return 'day';
    default:
      return 'month';
  }
};

export const useAdvancedDateRangePicker = (initialDateRange = defaultDateRange) => {
  const [dateRange, setDateRange] = useState(initialDateRange);

  const handleNavigateDate = useCallback(
    (rangeType, direction) => {
      const unit = getNavigateUnit(rangeType);
      const step = direction === 'Previous' ? -1 : 1;

      setDateRange(prevRange => {
        if (!prevRange?.startDate || !prevRange?.endDate) return prevRange;
        const startDateTime = moment(prevRange.startDate).add(step, unit).toDate();
        const endDateTime = moment(prevRange.endDate).add(step, unit).toDate();
        return {
          startDate: startDateTime,
          endDate: endDateTime,
          rangeType,
          key: 'selection'
        };
      });
    },
    [setDateRange]
  );

  return {
    dateRange,
    setDateRange,
    handleNavigateDate
  };
};
